import PropTypes from 'prop-types';
import className from 'classnames';
import Tooltip from 'react-tooltip-lite';
import { ReactSVG } from 'react-svg';

import { formatPrice } from 'utils/price';
import { i18n as I18n } from 'utils/i18n';
import { formatStartAndEndTimes } from 'utils/time';

import useIsMobile from '../../hooks/useIsMobile';

import {
  MOBILE_TOOLTIP_DISTANCE,
  DESKTOP_TOOLTIP_DISTANCE,
} from '../../constants/breakpoints';

const TimeSlot = ({
  startTime,
  endTime,
  cost,
  hasHelp,
  helpText,
  hasError,
  errorLabel,
}) => {
  const classes = className({
    // eslint-disable-next-line camelcase
    space__item: true,
    // eslint-disable-next-line camelcase
    space__timeslot: true,
    'space__timeslot--error': hasError,
  });

  const isMobileView = useIsMobile();

  const timeSlot = endTime
    ? formatStartAndEndTimes(startTime, endTime, 'HH:mm')
    : I18n.t('quick_book.space.please_select_a_timeslot');

  return (
    <li>
      <div className={classes} data-testid="spaceListItem">
        <span className="space__slot">
          {timeSlot}
          {hasHelp && (
            <div data-testid="spaceToolTip" data-cy="spaceToolTip">
              <Tooltip
                content={helpText}
                className="space__tooltip"
                distance={
                  isMobileView
                    ? MOBILE_TOOLTIP_DISTANCE
                    : DESKTOP_TOOLTIP_DISTANCE
                }
              >
                <ReactSVG
                  src="images/icons/question-mark.svg"
                  width={17}
                  height={17}
                />
              </Tooltip>
            </div>
          )}
          {hasError && (
            <span
              className="space__slot_error"
              data-testid="spaceListItemErrorLabel"
            >
              {' '}
              {!!errorLabel && ` (${errorLabel})`}
            </span>
          )}
        </span>

        <span className="space__price" data-testid="spacePrice">
          {formatPrice(cost)}
        </span>
      </div>
    </li>
  );
};

TimeSlot.propTypes = {
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  cost: PropTypes.number,
  hasHelp: PropTypes.bool,
  helpText: PropTypes.string,
  hasError: PropTypes.bool,
  errorLabel: PropTypes.string,
};

TimeSlot.defaultProps = {
  hasHelp: false,
  helpText: I18n.t('quick_book.space.slots_together_help'),
  hasError: false,
  errorLabel: '',
};

export default TimeSlot;
